<script setup>
defineProps({
  faqType: {
    type: String,
    required: false,
    default: null,

  },
  faqCategory: {
    type: String,
    required: false,
    default: null,
  },
})

const { t } = useI18n({})

const faq = inject('faq')
</script>

<template>
  <div class="flex flex-col gap-2">
    <NuxtLinkLocale
      :class="{ 'text-primary font-bold': faqType === null }"
      to="/faq/"
    >
      {{ t('faq.all') }}
    </NuxtLinkLocale>
    <div
      v-for="(type) in faq"
      :key="type.slug"
      class="flex flex-col gap-2 text-lg"
    >
      <NuxtLinkLocale
        :class="{ 'text-primary font-bold': faqType === type.slug }"
        :to="`/faq/${type.slug}/${type.children[0].slug}`"
      >
        {{ type.title }}
      </NuxtLinkLocale>
      <!-- Types -->
      <div
        v-if="faqType === type.slug"
        class="ml-4 flex flex-col gap-2"
      >
        <div
          v-for="(category) in type.children"
          :key="category.slug"
          :class="{ 'text-primary font-bold': faqCategory === category.slug }"
        >
          <NuxtLinkLocale
            class=""
            :to="`/faq/${type.slug}/${category.slug}`"
          >
            {{ category.title }}
          </NuxtLinkLocale>
        </div>
      </div>
    </div>
  </div>
</template>
